let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("WSq13")).then(() => parcelRequire('jffUe'));